
import { Link, useLocation } from 'react-router-dom';
import React from 'react';

interface NavLinkProps {
  name: string;
  href: string;
  isActive: boolean;
  isHomePage: boolean;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>, href: string) => void;
}

const NavLink: React.FC<NavLinkProps> = ({ name, href, isActive, isHomePage, onClick }) => {
  return (
    <Link 
      to={href.startsWith('#') && !isHomePage ? '/' + href : href}
      className={`nav-link text-sm font-medium transition-colors tracking-wide font-mono interactive-link ${
        isActive 
          ? 'text-primary' 
          : 'text-muted-foreground hover:text-primary/80'
      }`}
      onClick={(e) => onClick(e, href)}
    >
      {name}
    </Link>
  );
};

export default NavLink;
